"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/transfer-request-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Ftransfer-request-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferRequestStatusToJSON = exports.transferRequestStatusFromJSON = exports.TransferRequestStatus = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto.transfer';
var TransferRequestStatus;
(function (TransferRequestStatus) {
    TransferRequestStatus["INVALID_REQUEST_STATUS"] = "INVALID_REQUEST_STATUS";
    /**
     * PENDING - Transfer request has been sent and has not been acted upon.
     */
    TransferRequestStatus["PENDING"] = "PENDING";
    /**
     * TRANSFER_INITIATED - Transfer has been initiated but has not been complete. If the sender is
     * using an external account to fund their account first, the transfer may
     * be in this state while we wait for the payment to clear. Once the payment
     * is cleared, we change the transfer status to FULFILLED.
     * Also applies when sending transfer to non-Step accounts. Once the payment
     * is cleared and put on hold, we change the transfer status to PENDING.
     * In cases when the non-Step counterparty joins prior to the funding,
     * then we immediately transfer the funds and set the transfer status to
     * FULFILLED, thus bypassing PENDING state.
     */
    TransferRequestStatus["TRANSFER_INITIATED"] = "TRANSFER_INITIATED";
    /**
     * FULFILLED - Request has been fulfilled.
     */
    TransferRequestStatus["FULFILLED"] = "FULFILLED";
    /**
     * REJECTED - Request has been rejected by the counterparty.
     */
    TransferRequestStatus["REJECTED"] = "REJECTED";
    /**
     * DELETED - Request has been deleted:
     *  - by user, when they cancel the request
     *  - by user, when they delete expired/rejected request
     *  - by system, when the request is past the pre-defined interval for
     *    removal from when it is EXPIRED/REJECTED
     */
    TransferRequestStatus["DELETED"] = "DELETED";
    /**
     * EXPIRED - Request has expired.
     */
    TransferRequestStatus["EXPIRED"] = "EXPIRED";
    /**
     * FAILED - Failed to fulfill transfer request.
     */
    TransferRequestStatus["FAILED"] = "FAILED";
    TransferRequestStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferRequestStatus || (exports.TransferRequestStatus = TransferRequestStatus = {}));
function transferRequestStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REQUEST_STATUS':
            return TransferRequestStatus.INVALID_REQUEST_STATUS;
        case 1:
        case 'PENDING':
            return TransferRequestStatus.PENDING;
        case 2:
        case 'TRANSFER_INITIATED':
            return TransferRequestStatus.TRANSFER_INITIATED;
        case 3:
        case 'FULFILLED':
            return TransferRequestStatus.FULFILLED;
        case 4:
        case 'REJECTED':
            return TransferRequestStatus.REJECTED;
        case 5:
        case 'DELETED':
            return TransferRequestStatus.DELETED;
        case 6:
        case 'EXPIRED':
            return TransferRequestStatus.EXPIRED;
        case 7:
        case 'FAILED':
            return TransferRequestStatus.FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferRequestStatus.UNRECOGNIZED;
    }
}
exports.transferRequestStatusFromJSON = transferRequestStatusFromJSON;
function transferRequestStatusToJSON(object) {
    switch (object) {
        case TransferRequestStatus.INVALID_REQUEST_STATUS:
            return 'INVALID_REQUEST_STATUS';
        case TransferRequestStatus.PENDING:
            return 'PENDING';
        case TransferRequestStatus.TRANSFER_INITIATED:
            return 'TRANSFER_INITIATED';
        case TransferRequestStatus.FULFILLED:
            return 'FULFILLED';
        case TransferRequestStatus.REJECTED:
            return 'REJECTED';
        case TransferRequestStatus.DELETED:
            return 'DELETED';
        case TransferRequestStatus.EXPIRED:
            return 'EXPIRED';
        case TransferRequestStatus.FAILED:
            return 'FAILED';
        case TransferRequestStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferRequestStatusToJSON = transferRequestStatusToJSON;
//# sourceMappingURL=transfer-request-status.js.map